import React, { FC, PropsWithChildren, useEffect, useState } from "react";

import { PageProps } from "gatsby";

import Footer from "@layouts/Footer";
import Header from "@layouts/Header";
import ModalProvider from "@providers/ModalProvider";

import { Cart } from "@components/widgets";
import Modal from "@components/modal";
import useLocalStorageState from "use-local-storage-state";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import { getItemsFromLocalStorage, hydrateSharedCart } from "@store/cart";
import WizardProvider from "@providers/WizardProvider";
import Overlay from "@components/Overlay";
import { StripeProvider } from "@providers/StripeProvider";
import {
  decodeSharedCartParam,
  sharedCartParamKey,
} from "@helpers/cart/shareableCart";

type Props = PropsWithChildren & PageProps;

const Layout: FC<Props> = ({ children, location }) => {
  const params = new URLSearchParams(location.search || "");
  const gclid = params.get("gclid");

  const [_, setGCLID] = useLocalStorageState<string>("mp-gclid");
  const [isShowOverlay, setIsShowOverlay] = useLocalStorageState<boolean>("isShowAgeOverlay", {
    defaultValue: true,
  });
  const [hasWindow, setHasWindow] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setHasWindow(true);
  }, []);

  useEffect(() => {
    if (!hasWindow) return;

    const searchParams = new URLSearchParams(window.location.search);
    const shareParam = searchParams.get(sharedCartParamKey);

    if (shareParam) {
      const sharedCartItems = decodeSharedCartParam(shareParam);

      if (sharedCartItems) {
        dispatch(hydrateSharedCart(sharedCartItems));
      } else {
        dispatch(getItemsFromLocalStorage());
      }

      searchParams.delete(sharedCartParamKey);
      const nextSearch = searchParams.toString();
      const replacementUrl = `${window.location.pathname}${
        nextSearch ? `?${nextSearch}` : ""
      }${window.location.hash}`;

      window.history.replaceState({}, "", replacementUrl);

      return;
    }

    dispatch(getItemsFromLocalStorage());
  }, [dispatch, hasWindow]);

  useEffect(() => {
    if (!hasWindow || !gclid) return;

    setGCLID(gclid);
  }, [gclid, hasWindow, setGCLID]);

  if (!hasWindow) return null;

  // if (isShowOverlay && hasWindow && location.pathname === "/")
  //   return <Overlay onEnter={() => setIsShowOverlay(false)} />;

  if (location.pathname.includes("/wizard")) {
    return (
      <WizardProvider>
        <main className="wizard-page-container">{children}</main>
      </WizardProvider>
    );
  }

  if (location.pathname.includes("/checkout")) {
    return (
      <ModalProvider>
        <Modal />
        <main className="checkout-page-container">{children}</main>
      </ModalProvider>
    );
  }

  if (location.pathname.includes("/thankyou")) {
    return (
      <StripeProvider>
        <ModalProvider>
          <Modal hideCloseButton />
          <main className="checkout-page-container">{children}</main>
        </ModalProvider>
      </StripeProvider>
    );
  }

  const locationName = location.pathname.slice(
    location.pathname.lastIndexOf("/", location.pathname.length - 2) + 1,
    location.pathname.length - 1
  );

  return (
    <div className={classNames("root", `${locationName}-page`)}>
      <ModalProvider>
        <Header location={location} />
        <Cart />
        <Modal />

        <main>{children}</main>

        <Footer />
      </ModalProvider>
    </div>
  );
};

export default Layout;
